/** Available current time frames. Stored in number of months */
export enum TimeFrame {
  CurrentMonth = 0,
  LastMonth = 1,
  Last3Months = 3,
  Last6Months = 6,
  Last12Months = 12,
}

/** Available comparisons. Stored in number of years */
export enum CompareTo {
  PreviousPeriod = 0,
  SamePeriodLastYear = 1,
  SamePeriodTwoYearsAgo = 2,
}

// Lodash sort orders. Please do not change
export enum Sorting {
  Asc = "asc",
  Desc = "desc",
}
